import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Typography, IconButton, Box } from '@material-ui/core';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Helmet from 'react-helmet';

import { ViewInAppButton } from 'components/ViewInAppButton';
import { getAppDomain } from 'utils/getAppDomain';
import { Challenge } from 'generated/graphql';
import User from 'entities/user/model';
import Organization from 'entities/organization/model';
import { ChallengePageDetails } from './ChallengePageDetails';
import { ChallengeImageBox } from './ChallengeImageBox';
import { TeamsList } from './TeamList';

interface ChallengePageProps {
  challenge: Challenge;
  user?: User;
  organization?: Organization;
}

const ChallengePage = ({ challenge, user, organization }: ChallengePageProps) => {
  const history = useHistory();

  const handleEditDetails = () => {
    history.push(`/challenges/${challenge.id}/edit`);
  };

  const handleBackClick = () => {
    if (history.length > 0) {
      history.goBack();
    } else {
      history.push('/challenges');
    }
  };

  return (
    <Box>
      <Helmet title={challenge.title} />

      <Box
        style={{
          display: 'flex',
          flexFlow: 'row wrap',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 20,
        }}
      >
        <Box style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
          <IconButton onClick={handleBackClick} style={{ marginRight: 16 }} aria-label="Go back">
            <ArrowBackIcon />
          </IconButton>

          <Typography
            component="h1"
            style={{ fontSize: 32, fontWeight: 700, marginTop: 0, marginBottom: 0 }}
          >
            {challenge.title}
          </Typography>
        </Box>

        <Box style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <ViewInAppButton
            href={`${getAppDomain([organization, user])}/challenge/${challenge.id}`}
            text="View in App"
            style={{
              textDecorationLine: 'underline',
              textUnderlinePosition: 'under',
            }}
            disabled={challenge.status !== 'published'}
          />

          <Button
            variant="contained"
            color="primary"
            onClick={handleEditDetails}
            style={{ textTransform: 'none' }}
          >
            Edit Details
          </Button>
        </Box>
      </Box>

      <div style={{ display: 'flex', gap: 20, marginTop: 40 }}>
        <div style={{ flex: 1 }}>
          <ChallengeImageBox challenge={challenge} onEditDetails={handleEditDetails} />
        </div>

        <div style={{ flex: 1 }}>
          <ChallengePageDetails challenge={challenge} />
        </div>
      </div>

      <div style={{ display: 'flex', gap: 20 }}>
        <div style={{ flex: 1 }}>
          <TeamsList challenge={challenge} />
        </div>
        <div style={{ flex: 1 }}></div>
      </div>
    </Box>
  );
};

export default ChallengePage;
